var exports = {
  "Q": "x31de4314--72ebed--content",
};

module.exports = exports;
